module.exports = __webpack_public_path__ + "img/Turkey.51ef07be.svg";